/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import { Outlet } from "react-router-dom";
import { useTheme } from "@mui/material";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useAuth } from "../context/AuthContext";
import { AssistantProvider } from "./apps/drive/assistant";
import AssistantPanel from "./apps/drive/assistant/components/AssistantPanel";

/**
 * Shell layout, matching accounts: full-height sidebar on the left so the logo
 * never moves, then a column whose navbar spans only the content area, with the
 * assistant docking beside the page rather than over it.
 */
const Body = () => {
  const theme = useTheme();
  const { user } = useAuth();

  return (
    <AssistantProvider>
      <div
        style={{
          display: "flex",
          backgroundColor: theme.palette.primary.main,
          height: "100vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Sidebar />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minWidth: 0,
            height: "100%",
          }}
        >
          <div
            style={{
              position: "sticky",
              top: 0,
              zIndex: 100,
              backgroundColor: theme.palette.secondary.main,
              flexShrink: 0,
            }}
          >
            <Navbar />
          </div>

          <div
            style={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div style={{ flex: 1, minWidth: 0, height: "100%", overflow: "auto" }}>
              <Outlet />
            </div>
            <AssistantPanel userName={user?.given_name || user?.name} />
          </div>
        </div>
      </div>
    </AssistantProvider>
  );
};

export default Body;
